
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IUpdateAllocation } from '@routes/events/models/ticketallocation-model';
import { AddAllocationUser, IAllocations, IAvailableTickets, IInvitationType, IRequestTickets, ITicketHoldersForDropdown } from '@shared/services/api/legacy/allocations-service/allocations-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class AllocationsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${AllocationsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events/{eventId}/allocations';

    public getAllocations(id: string): Observable<SuccessResponse<IAllocations> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IAllocations>>(AllocationsService.URL.replace('{eventId}', id)).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addAllocationUsers(eventId: string, model: AddAllocationUser): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(AllocationsService.URL.replace('{eventId}', eventId), model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getInvitationType(id: string): Observable<SuccessResponse<IInvitationType> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IInvitationType>>(AllocationsService.URL.replace('{eventId}', id) + '/invitationtype').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getAvailableTickets(id: string): Observable<SuccessResponse<IAvailableTickets> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IAvailableTickets>>(AllocationsService.URL.replace('{eventId}', id) + '/availabletickets').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateAllocations(id: string, model: IUpdateAllocation): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(AllocationsService.URL.replace('{eventId}', id), model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public requestAllocation(id: string, request: IRequestTickets): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(AllocationsService.URL.replace('{eventId}', id) + '/request', request).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getTicketHoldersForDropdown(id: string): Observable<SuccessResponse<ITicketHoldersForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ITicketHoldersForDropdown>>(AllocationsService.URL.replace('{eventId}', id) + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getTicketHoldersForFilterDropdown(id: string): Observable<SuccessResponse<ITicketHoldersForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ITicketHoldersForDropdown>>(AllocationsService.URL.replace('{eventId}', id) + '/filter').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
